import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ContentCategoryForm from '../../../components/forms/ContentCategoryForm';
import { useContentCategoryApi } from '../../../hooks/useContentCategoryApi';
import { useNavigate } from 'react-router-dom';
import { ContentCategoryDTO } from '../../../services/apiClient';

const ContentCategoryCreate: React.FC = () => {
  const { create, isLoading } = useContentCategoryApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Content Categories', href: '/admin/contentcategories' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ContentCategoryDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/contentcategories');
    } catch (error) {
      console.error('Error creating ContentCategory:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/contentcategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ContentCategory.Edit'
    >
        <ContentCategoryForm
          initialValues={{} as ContentCategoryDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/contentcategories')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default ContentCategoryCreate;